// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"4e83751c","576":"182fece5"}[chunkId] + ".chunk.js";
};